/* eslint-disable import/prefer-default-export */

export type UploadedCSV = {
  id: number,
  originalname: number,
  totalRows: number,
  unsubscribedCount: number,
  throttledCount: number,
  invalidCount: number,
  failedCount: number,
  sentCount: number,
  revokedCount: number,
  suspendedCount: number,
  suspendedDevsCount: number,
  inactiveAccountCount: number,
  esp: string,
  status:
    | 'processing'
    | 'completed'
    | 'uploaded'
    | 'scheduled'
    | 'paused'
    | 'aborted',
  owner: string,
  uploadedTime: string,
  scheduledTime: string,
  template: {
    id: number,
  },
  user: {
    id: number,
  },
};

export type QueryFilter = {
  page: number,
  limit: number,
  userId: number,
  search: string,
};

export const calPercent = (total, value) => {
  const result = (value / total) * 100;
  if (Number.isNaN(result)) return 0;
  return result >= 100 ? 100 : result < 0 ? 0 : result;
};
